var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100vh"}},[(_vm.$device.isDesktop)?_c('nuxt'):_vm._e(),_vm._v(" "),(_vm.$device.isDesktop)?_c('snack-bar-errors'):_vm._e(),_vm._v(" "),(_vm.$device.isDesktop === false)?_c('redirect-to-app'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }